import {
  View,
  Page,
  Text,
  Document,
  StyleSheet,
  Font,
} from "@react-pdf/renderer"
import unimedSansRegular from "../../assets/fonts/unimedsans-regular-webfont.woff"
import unimedSansBold from "../../assets/fonts/unimedsans-bold-webfont.woff"

Font.register({
  family: "unimed_sans",
  fonts: [
    { src: unimedSansRegular, fontWeight: "normal" },
    { src: unimedSansBold, fontWeight: "bold" },
  ],
})

Font.registerEmojiSource({
  format: "png",
  url: "https://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/72x72/",
  withVariationSelectors: true,
})

const styles = StyleSheet.create({
  page: {
    padding: 20,
    fontFamily: "unimed_sans",
  },
  section: {
    margin: 10,
    padding: 10,
  },
  list_item__title: {
    fontFamily: "unimed_sans",
    fontWeight: "bold",
    fontSize: 16,
    marginBottom: 15,
    color: "#000",
  },

  list_item__paragraph: {
    fontSize: 12,
    marginBottom: 6,
    lineHeight: 1.4,
    color: "#000",
  },
  list_item__label: {
    fontFamily: "unimed_sans",
    fontWeight: "bold",
    color: "#000",
  },

  line: { borderBottom: "2px solid black", marginBottom: 14 },
})

const ActivitiesPdf = ({ activities }) => {
  console.log(activities)
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {activities &&
          activities.map((it) => (
            <View key={it.id} style={styles.section}>
              <View style={styles.line}></View>

              <Text style={styles.list_item__title}>{it.name}</Text>

              <Text style={styles.list_item__paragraph}>
                <Text style={styles.list_item__label}>
                  Nível da atividade:{" "}
                </Text>
                {it.ability_score}
              </Text>

              <Text style={styles.list_item__paragraph}>
                <Text style={styles.list_item__label}>
                  Subnível (progressão) da atividade:{" "}
                </Text>
                {it.subscore}
              </Text>

              <Text style={styles.list_item__paragraph}>
                <Text style={styles.list_item__label}>Habilidade: </Text>
                {it.ability}
              </Text>

              <Text style={styles.list_item__paragraph}>
                <Text style={styles.list_item__label}>Descrição: </Text>{" "}
                {it.description}
              </Text>

              <Text style={styles.list_item__paragraph}>
                <Text style={styles.list_item__label}>
                  Materiais requeridos:{" "}
                </Text>
                {it.required_materials}
              </Text>

              <Text style={styles.list_item__paragraph}>
                <Text style={styles.list_item__label}>Instruções: </Text>
                {it.instruction}
              </Text>

              <Text style={styles.list_item__paragraph}>
                <Text style={styles.list_item__label}>
                  Quantidade de participantes:{" "}
                </Text>
                {it.participants_quantity}
              </Text>

              <Text style={styles.list_item__paragraph}>
                <Text style={styles.list_item__label}>Tipo de sala: </Text>
                {it.space_type}
              </Text>

              <Text style={styles.list_item__paragraph}>
                <Text style={styles.list_item__label}>Tamanho da sala: </Text>
                {it.space_size}
              </Text>

              <Text style={styles.list_item__paragraph}>
                <Text style={styles.list_item__label}>
                  Quantidade de salas:{" "}
                </Text>
                {it.space_quantity}
              </Text>
            </View>
          ))}
      </Page>
    </Document>
  )
}

export default ActivitiesPdf
